<script>
import { AxiosAPI } from '@/axios';
import { useResponseStore, useMainStore, useEventStore } from '../../../stores/index';
import ProgressBarDocs from './ProgressBarResp.vue';
import Swal from 'sweetalert2';
export default {
  name: 'DashboardDefault',
  components: { ProgressBarDocs },
  setup () {
    const Main = useMainStore();
    const Store = useResponseStore();
    const Events = useEventStore();
    return {
      StoreMain: Main,
      StoreResp: Store,
      Events
    };
  },
  data () {
    return {
      LoadingPreview: false,
      expandedRows: {},
      tableKeys: [],
      DataUsers: [],
      Signers: [],
      attachment_signers: [],
      tableNoFormat: [],
      checked: false,
      loading: false
    };
  },
  mounted () {
    if (this.StoreResp.SignersData.Signers !== undefined) {
      this.tableKeys = this.StoreResp.SignersData.tableKeys;
      this.Signers = this.StoreResp.SignersData.Signers;
      this.DataUsers = this.StoreResp.SignersData.DataUsers;
    }

    if (this.StoreResp.SignersData.Signers === undefined) {
      this.GetServidoresSolo();
    }
  },
  computed: {
  },
  watch: {
    DataUsers: function (newValue) {
      const Signers = [];
      this.tableKeys.forEach(element => {
        element.children.forEach(users => {
          newValue.forEach(values => {
            if (users.value === values) {
              Signers.push(users);
            }
          });
        });
      });
      this.Signers = Signers;
    }
  },
  methods: {
    async nextProgress () {
      this.LoadingPreview = true;
      const requiredSigners = [];
      const signers = [];
      const AttachSigner = [];
      const AllSigners = [];
      this.Signers.forEach(element => {
        if (element.signer === true) {
          requiredSigners.push(element.toSendID);
        }
        if (element.signer === false) {
          signers.push(element.toSendID);
        }
      });

      this.Signers.forEach(element => {
        if (element.attachment_signer === true) {
          AttachSigner.push(element.toSendID);
        }
      });

      AllSigners.push(...requiredSigners, ...signers);

      this.StoreResp.documentData.required_signers = requiredSigners;
      this.StoreResp.documentData.signers = AllSigners;
      this.StoreResp.SignersData.Signers = this.Signers;
      this.StoreResp.documentData.attachment_signer = AttachSigner;
      this.StoreResp.SignersData.DataUsers = this.DataUsers;
      const data = {
        title: this.StoreResp.documentData.subject || 'Documento',
        subject: this.StoreResp.documentData.subject,
        body: this.StoreResp.documentData.body,
        document_type_id: this.StoreResp.documentData.typeDoc,
        to_users: this.StoreResp.documentData.to_users,
        to_departments: this.StoreResp.documentData.to_departments,
        user_id: this.StoreResp.documentData.user_id,
        department_id: this.StoreResp.documentData.department_id
      };
      await AxiosAPI.post('/api/documents/preview/', data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.StoreMain.accessToken
        }
      })
        .then((resp) => {
          this.StoreResp.pdf64 = resp.data.file;
          this.LoadingPreview = false;
          this.StoreResp.progress += 1;
        })
        .catch((error) => {
          this.LoadingPreview = false;
          let errorMessage = 'Não foi possível gerar a pré-visualização do documento.';
          if (error.response && error.response.status === 422) {
            const errors = error.response.data && error.response.data.errors;
            if (errors && errors.body) {
              errorMessage = 'O corpo do documento é obrigatório. Por favor, volte à etapa de dados e preencha o texto do documento.';
            } else if (error.response.data && error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          } else if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }

          Swal.fire({
            title: 'Erro na pré-visualização',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#F1860B',
            customClass: {
              title: 'font-docs',
              htmlContainer: 'font-docs',
              confirmButton: 'font-docs'
            }
          });
        });
    },
    backProgress () {
      this.StoreResp.progress -= 1;
    },
    async getUserNow () {
      await AxiosAPI.get('/api/departments/group/', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.StoreMain.accessToken
        }
      })
        .then((resp) => {
          const myUserData = [];
          const myUserValue = [];
          let leader = [];
          const Signers = [];
          resp.data.departments.forEach(element => {
            element.users.forEach(users => {
              if (users.id === this.StoreMain.user.id) {
                if (users.cpf === this.StoreMain.user.cpf) {
                  if (this.StoreMain.user.is_leader === true) {
                    if (myUserData.some(item => item.cpf === users.cpf)) {
                      this.LeaderFalse = false;
                    } else {
                      myUserData.push(users);
                      myUserValue.push(users.value);
                    }
                  }
                  if (this.StoreMain.user.is_leader === false) {
                    leader = this.StoreMain.user.leader;
                    this.tableKeys.forEach(element => {
                      element.children.forEach(liderValue => {
                        if (liderValue.cpf === leader.cpf) {
                          if (myUserData.some(item => item.cpf === users.cpf)) {
                            this.LeaderFalse = true;
                          } else {
                            myUserData.push(users);
                            myUserValue.push(users.value, liderValue.value);
                          }
                        }
                      });
                    });
                  }
                  if (this.StoreMain.user.is_leader === null) {
                    console.log('is_leader === null');
                  }
                }
              }
            });
          });
          this.DataUsers = myUserValue;

          this.tableKeys.forEach(element => {
            element.children.forEach(users => {
              myUserValue.forEach(values => {
                if (users.value === values) {
                  if (users.cpf === this.StoreMain.user.cpf) {
                    if (this.StoreMain.user.is_leader === true) {
                      Signers.push(users);
                    }
                    if (this.StoreMain.user.is_leader === false) {
                      leader = this.StoreMain.user.leader;
                      this.tableKeys.forEach(element => {
                        element.children.forEach(liderValue => {
                          if (liderValue.cpf === leader.cpf) {
                            liderValue.signer = true;
                            users.signer = true;
                            Signers.push(liderValue, users);
                          }
                        });
                      });
                    }
                    if (this.StoreMain.user.is_leader === null) {
                      console.log('is_leader === null');
                    }
                  }
                }
              });
            });
          });
          this.Signers = Signers;
        });
    },

    async GetServidoresSolo () {
      this.DataUsers = [];
      this.Signers = [];
      await AxiosAPI.get('/api/departments/group/', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.StoreMain.accessToken
        }
      })
        .then((resp) => {
          const data = [];
          for (let i = 0; i < resp.data.departments.length; i++) {
            const obj = resp.data.departments[i];

            obj.label = obj.title;
            delete obj.title;

            obj.key = obj.value;
            delete obj.value;

            obj.children = obj.users;
            delete obj.users;
            for (let i = 0; i < obj.children.length; i++) {
              const childrens = obj.children[i];
              childrens.toSendID = childrens.id;
              delete childrens.id;
              childrens.id = childrens.value;

              childrens.label = childrens.name;
              delete childrens.name;

              childrens.signer = false;
              childrens.attachment_signer = false;
              childrens.send = false;
            }
            data.push(obj);
          }
          this.tableKeys = data;
          this.StoreResp.SignersData.tableKeys = this.tableKeys;
          this.getUserNow();
        });
    },
    toggleSigner (row) {
      row.signer = row.signer !== true;
    },
    toggleAttachmentSigner (row) {
      row.attachment_signer = !row.attachment_signer;
    },
    toggleInbox (row) {
      row.inbox = row.inbox !== true;
    },
    removeLine (values) {
      this.DataUsers = this.DataUsers.filter(item => item !== values.value);
    }
  }
};
</script>
<style>
.drop-zone--over {
  background-color: #d4edf7;
}
.form-check-input:checked{
  border-color: #F1860B !important;
  background-color: #F1860B !important;
  padding-bottom: 18px;
}
.p-datatable-header{
    background-color: #E9ECEF !important;
  }
</style>

<template>
  <div class="container">
    <ProgressBarDocs />
    <div v-if="LoadingPreview" class="row d-flex justify-content-center align-items-center mt-5">
      <ProgressBar class="mt-5" mode="indeterminate" style="height: 6px;width:50%"></ProgressBar>
      <span class="d-flex justify-content-center align-items-center font-docs">carregando, previsualização...</span>
    </div>
    <div v-if="!LoadingPreview" class="w-100 mt-3">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h4 class="font-docs text-docs-black"><b>Assinaturas</b></h4>
        </div>
    </div>
    <div v-if="!LoadingPreview">
      <hr>
      <div>
        <div class="mt-4 ml-2">
           <span> Assinante(s) <span style="color: red;">*</span></span>
        </div>
       <treeselects v-model="DataUsers" :disable-branch-nodes="true" :flat="true" placeholder="Busque por nome ou nome do departamento"  :multiple="true" :options="tableKeys" ></treeselects>
            <DataTable :value="Signers" :responsive="true" :loading='loading'>
              <Column header='Servidor' :sortable="true" class='text-sm font-weight-bold text-wrap font-docs-recived-header' headerStyle='width: 10rem; font-size: 16px !important'>
                <template #body="slotProps">
                  <div v-if="!this.StoreMain.mobile" class="d-flex">
                    <div>
                      <img :src="$userAvatar(slotProps.data.path_image)"
                        alt="Avatar"
                        style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;" />
                    </div>
                    <div class="d-grid ml-2">
                      <span class="font-docs font-weight-bold"> {{ slotProps.data.label }} </span>
                      <span class="font-docs font-weight-bold"> {{ slotProps.data.email  }} </span>
                    </div>
                  </div>
                  <div v-if="this.StoreMain.mobile">
                    <div  class="d-flex justify-content-end">
                      <img :src="$userAvatar(slotProps.data.path_image)"
                                  alt="Avatar"
                                  style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;" />
                    </div>
                    <div class="d-grid ml-2 text-end">
                      <span  class="font-docs font-weight-bold"> {{ slotProps.data.label }} </span>
                      <span  class="font-docs font-weight-bold"> {{ slotProps.data.email  }} </span>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field='role' header='Cargo' :sortable="true" class='text-sm font-weight-bold text-wrap font-docs-recived-header' headerStyle='width: 10rem; font-size: 16px !important'>
              </Column>
              <Column field='departments' header='Setor' :sortable="true" class='text-sm font-weight-bold text-wrap font-docs-recived-header' headerStyle='width: 10rem; font-size: 16px !important'>
                <template #body="slotProps">
                  <span v-if="slotProps.data.departments.length <= 0">Departamento não definido</span>
                  <span v-if="slotProps.data.departments.length >= 1">{{slotProps.data.departments[0].title}}</span>
                </template>
              </Column>
              <Column header='Assinar anexo' class='text-sm font-weight-bold text-wrap font-docs-recived-header' headerStyle='width: 10rem; font-size: 16px !important'>
                <template #body="slotProps">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch"
                      :id="'switch-attachment-' + slotProps.data.id"
                      v-model="slotProps.data.attachment_signer"
                      @click="toggleAttachmentSigner(slotProps.data)"
                      :disabled="slotProps.data.profile === 'Leitor' || this.StoreResp.documentData.attachments.length <= 0">
                  </div>
                </template>
              </Column>
               <Column header='Assinatura obrigatória' class='text-sm font-weight-bold text-wrap font-docs-recived-header' headerStyle='width: 10rem; font-size: 16px !important'>
                <template #body="slotProps">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" :id="'switch-' + slotProps.data.signer" v-model="slotProps.data.signer" @click="toggleSigner(slotProps.data)" :disabled="slotProps.data.profile === 'Leitor' || !slotProps.data.attachment_signer">
                  </div>
                </template>
              </Column>
             <Column class='text-sm font-weight-bold text-wrap font-docs' headerStyle='width: 2rem; font-size: 16px !important;'>
                <template #body="slotProps">
                  <div class="d-flex justify-content-end">
                  <font-awesome-icon :icon="['fas', 'trash-can']" style="cursor: pointer;font-size: 16px;" @click="removeLine(slotProps.data)"/>
                  </div>
                </template>
              </Column>
            </DataTable>
      </div>
      <div class="d-flex justify-content-end">
          <button class="btn mt-3 font-docs Color-Docs" style="border: 1px solid #F1860B" @click="backProgress()">Voltar</button>
          <button class="btn mt-3 ml-3 font-docs text-white background-Docs" @click="nextProgress()">Avançar</button>
      </div>
      </div>
</div>
</template>
